import React from 'react';
import { GlobeIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { CheckList } from '../CheckList';
import { CountdownTimer } from '../CountdownTimer';
import { ScarcityBar } from '../ScarcityBar';
import { images, offerChecks, valueStack } from '../../data/offer';
export function Offer() {
  const total = valueStack.reduce((sum, v) => sum + v.value, 0);
  return <section id="offer" className="w-full bg-navy px-4 py-16 sm:px-6 lg:py-24" aria-labelledby="offer-title" data-id="element-190" data-mp="3a5p30ew6600a">
      <div className="mx-auto max-w-3xl" data-id="element-191" data-mp="3f3qiyqyatj7j">
        <h2 id="offer-title" className="text-balance text-center font-display text-[28px] font-extrabold leading-[1.15] tracking-tight text-white sm:text-4xl lg:text-[44px]" data-id="element-192" data-mp="3f2p8oop3x0qv">
          Everything You Need to Organize Your Clear Aligner Case Reviews in <span className="text-gold" data-id="element-193" data-mp="3sw6mrtz0xl9i">One Collection</span>
        </h2>

        <div className="mt-8 overflow-hidden rounded-3xl bg-white" data-id="element-194" data-mp="3su3pcovjkpur">
          <img src={images.mockup} alt="Complete Clear Aligner Clinical Blueprint collection" className="w-full" data-id="element-195" data-mp="1q5a5gzeujlr" />
          <div className="p-5 sm:p-8" data-id="element-196" data-mp="1kmrmcbwyz67a">
            <div className="flex items-end justify-between gap-4 border-b-2 border-navy pb-2 text-[11px] font-extrabold uppercase text-ink-muted sm:text-xs" data-id="element-197" data-mp="1fmn9qwz6mvmc">
              <span data-id="element-198" data-mp="1bl1w39etqdb3">Included resource</span>
              <span className="text-right" data-id="element-199" data-mp="16m8i7fvmkkae">Suggested reference value</span>
            </div>
            <ul className="divide-y divide-navy/10" data-id="element-200" data-mp="23bpy0nobnmpt">
              {valueStack.map(v => <li key={v.label} className="flex items-start justify-between gap-4 py-3 text-[14px] leading-snug text-ink sm:text-[15px]" data-id="element-201" data-mp="1zamjc4i0fwq6">
                  <span className="font-medium" data-id="element-202" data-mp="1uicw4w8a5arl">{v.label}</span>
                  <span className="shrink-0 font-bold text-ink-muted" data-id="element-203" data-mp="1pl2zavik9wtq">${v.value}</span>
                </li>)}
            </ul>
            <div className="mt-2 flex items-center justify-between gap-4 rounded-2xl bg-[#F6F8FC] p-4" data-id="element-204" data-mp="2n1i6gobiu3r3">
              <span className="text-sm font-bold text-navy sm:text-base" data-id="element-205" data-mp="2i7ns80eoqgze">Illustrative combined reference value</span>
              <span className="shrink-0 font-display text-xl font-extrabold text-danger line-through" data-id="element-206" data-mp="317k49hge6pby">${total} USD</span>
            </div>
            <p className="mt-2 text-xs text-ink-soft" data-id="element-207" data-mp="2sdoz49f9sywb">These are suggested reference values, not verified market prices or independently established savings.</p>
          </div>
        </div>

        <div className="mt-8 rounded-3xl border-2 border-gold bg-navy-800 p-5 text-center sm:p-8" data-id="element-208" data-mp="2if97m5cbznma">
          <p className="font-display text-base font-extrabold uppercase text-gold" data-id="element-209" data-mp="2ndswadib7dic">Your price today</p>
          <p className="mt-1 text-lg text-white/70" data-id="element-210" data-mp="29ekvjg6hzxc1">
            Instead of <s data-id="element-211" data-mp="29ge2kwl0wjkk">${total}</s>
          </p>
          <p className="font-display text-[72px] font-extrabold leading-none text-white sm:text-[96px]" data-id="element-212" data-mp="2dfd3m63mvw6q">
            <span className="align-top text-3xl sm:text-4xl" data-id="element-213" data-mp="7mohnzwuybe3">$</span>27
            <span className="ml-1 text-xl font-bold text-white/70 sm:text-2xl" data-id="element-214" data-mp="bojgmxrbgcop">USD</span>
          </p>
          <p className="mx-auto mt-3 max-w-md text-pretty text-white/80" data-id="element-215" data-mp="1w6kaz63i61ma">
            Get the complete six-volume collection and all five bonuses for one payment of $27 USD.
          </p>

          <div className="mx-auto mt-5 flex w-fit items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm font-semibold text-white" data-id="element-216" data-mp="1s35sm8s3d95o">
            <GlobeIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-217" data-mp="215f5346x7clp" />
            Currency conversion to your local currency is automatic
          </div>

          <div className="mx-auto mt-6 max-w-md text-left" data-id="element-218" data-mp="2fwe8m0swfayf">
            <CheckList items={offerChecks} tone="dark" data-id="element-219" data-mp="2auowsixuqt9a" />
          </div>

          <div className="mt-8 flex flex-col items-center gap-6" data-id="element-220" data-mp="2ovhqx2k8rmbv">
            <ScarcityBar data-id="element-221" data-mp="2jw560ncxkpbx" />
            <CtaButton label="Yes! I want the complete Blueprint for $27" showSecure={false} data-id="element-222" data-mp="2jvmxosczuknn" />
            <CountdownTimer data-id="element-223" data-mp="ugoy1baqt9nm" />
          </div>

          <p className="mx-auto mt-5 max-w-md text-xs leading-relaxed text-white/60" data-id="element-224" data-mp="uhgueoc5zbey">
            Please review the checkout page for the final price, payment terms, delivery details, and applicable refund policy.
          </p>
        </div>
      </div>
    </section>;
}